import { useState } from "react";
import { EditorState } from "draft-js";

import {
  RichTextArea,
  richTextFromHTML,
  richTextToHTML,
  TextField
} from "../FormInput";
import { StoreAction } from "./store";

type EditBlockProps = {
  block: Form.Block;
  closeModal: (evt: React.MouseEvent) => void;
  dispatch: (action: StoreAction) => void;
};

type EditBlockState = {
  name: string;
  description: EditorState;
};

export default function EditBlock(props: EditBlockProps) {
  const [state, setState] = useState<EditBlockState>(() => ({
    name: props.block.name,
    description: richTextFromHTML(props.block.description)
  }));

  const updateState = (newState: Partial<EditBlockState>) => {
    setState({ ...state, ...newState });
  };

  const save = (evt: React.MouseEvent) => {
    props.dispatch({
      type: "updateBlock",
      payload: {
        ...props.block,
        name: state.name,
        description: richTextToHTML(state.description)
      }
    });
    props.closeModal(evt);
  };

  return (
    <form className="modal-form">
      <h2>Endre blokk</h2>
      <div className="row">
        <TextField
          name="name"
          label="Navn"
          onChange={(val: string) => updateState({ name: val })}
          value={state.name}
          size={12}
        />
      </div>
      <div className="row">
        <RichTextArea
          name="description"
          label="Beskrivelse"
          onChange={(val: EditorState) => updateState({ description: val })}
          links={true}
          simple={true}
          value={state.description}
          size={12}
        />
      </div>
      <div className="buttons">
        <button type="submit" onClick={save}>
          Oppdater
        </button>
        <button onClick={props.closeModal}>Avbryt</button>
      </div>
    </form>
  );
}
